import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../utils";

export const sendChatMessage = createAsyncThunk('sendChatMessage', async (data) => {

    // console.log('Sending message:', data?.values?.item);
    try {
        const res = await axios({
            method: 'POST',
            url: process.env.REACT_APP_CHAT_URL + 'query',
            data: {
                "query": data?.values?.item,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        });
        // The response will have the format:
        // { answer: string, processing_time: number, context: array }
        return res;
    } catch (error) {
        return error.response;
    }
});

const loadingMessages = [
    "AI chatbot thinking...",
    "Please wait...",
    "Processing your request...",
    "Getting smarter...",
];

const sendChatMessageSlice = createSlice({
    name: "sendChatMessage",
    initialState: {
        isLoading: false,
        loadingMessage: '',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(sendChatMessage.pending, (state) => {
                state.isLoading = true;
                state.loadingMessage = loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
                state.error = null;
            })
            .addCase(sendChatMessage.fulfilled, (state) => {
                state.isLoading = false;
                state.loadingMessage = '';
                state.error = null;
            })
            .addCase(sendChatMessage.rejected, (state, action) => {
                state.isLoading = false;
                state.loadingMessage = '';
                // Prefer payload (rejectWithValue) message, fallback to action.error
                state.error = action.payload?.message || action.error?.message || 'Failed to send message.';
            });
    },
});

export default sendChatMessageSlice.reducer;

